import { useState } from "react";
import { fetchTransactionHistoryReportCsv } from "../api/fetchTransactionHistoryReport/fetchTransactionHistoryReportCsvApi";
import { FetchTransactionHistoryReportParams } from "../api/fetchTransactionHistoryReport/types";
import { downloadFile } from "@/utils/downloadFile";

export function useDownloadTransactionHistoryReportCsv() {
  const [loading, setLoading] = useState(false);

  const downloadCsv = async (
    params: Omit<FetchTransactionHistoryReportParams, "page" | "pageSize"> = {},
  ) => {
    setLoading(true);
    try {
      const blob = await fetchTransactionHistoryReportCsv(params);
      const date = new Date().toISOString().split("T")[0];
      downloadFile(blob, `transaction-history-report-${date}.csv`);
    } finally {
      setLoading(false);
    }
  };

  return { loading, downloadCsv };
}
